import { Monster } from '../types/Monster';
import { AIConfig, AILevel, DEFAULT_AI_CONFIG } from '../ai/types';

export const EREBOS_MONSTER: Monster = {
  id: 'erebos',
  name: 'エレボス',
  species: 'ゼノ',
  stats: {
    hp: 444,
    strength: 350,
    special: 350,
    speed: 300,
    toughness: 250,
    specialAttackCount: 5,
  },
  weapon: { name: '虚無の光翼', multiplier: 1.2 },
  reflector: { name: '神聖の盾', maxReflectCount: 5, reflectRate: 0.8 },
};

export const EREBOS_FORM2_MONSTER: Monster = {
  id: 'erebos_form2',
  name: 'エレボス（真の姿）',
  species: 'ゼノ',
  stats: {
    hp: 666,
    strength: 450,
    special: 380,
    speed: 130,
    toughness: 280,
    specialAttackCount: 10,
  },
  weapon: { name: '虚無', multiplier: 1.0 },
  reflector: { name: '混沌の渦', maxReflectCount: 2, reflectRate: 1.5 },
};

export const BOSS_IDS: readonly string[] = ['erebos', 'erebos_form2'];

export function isBossMonster(monsterId: string): boolean {
  return (BOSS_IDS as string[]).includes(monsterId);
}

export const EREBOS_AI_CONFIG: AIConfig = {
  ...DEFAULT_AI_CONFIG,
  thinkingLevel: AILevel.LV6,
  aggression: 50,
  specialPreference: 50,
  distancePreference: 50,
  stanceTendency: 50,
  reflectorUsage: 50,
  riskTolerance: 70,
  patternReading: 70,
  counterTendency: 60,
  adaptability: 70,
  metaReading: 65,
  unpredictability: 30,
  comboSynergy: 60,
  lookAheadDepth: 4,
  opponentModeling: 70,
  mixedStrategy: 30,
  resourceOptimization: 80,
};


export const BOSS_SPECIAL_RESISTANCE = 0.5;
export const BOSS_STAGE_NUMBER = 9;
export const BOSS_DISPLAY_SCALE = 1.5;
